import React, { useState, useEffect, useContext, useCallback } from "react";
import { useParams } from "react-router-dom";
import { DataContext } from "../../../context/DataContext";

import { getRol, getToken, getUser } from "../../../api/Account";
import { getClientsReportAsync } from "../../../api/Report";
import { simpleMessage } from "../../../helpers/Helpers";
import ReporteAgrupado from "../../../components/reportes/ReporteAgrupado";

// Enlaces anteriores: el último segmento de la ruta era 0 = por nombre, 1 = por promedio.
const ORDEN_POR_PROMEDIO = 1;

const ESTADOS = {
  0: "Clientes Activos",
  1: "Clientes Inactivos",
};

const texto = (key, label) => ({
  key,
  label,
  align: "left",
  texto: true,
  valor: (c) => c[key],
});

// "Ciclos" son los créditos ya cancelados del cliente y "Promedio" sus días de atraso
// promedio, que calcula el proceso nocturno.
const COLUMNAS = [
  texto("fullName", "Nombre Completo"),
  { ...texto("phone", "Teléfono"), align: "center" },
  texto("address", "Dirección"),
  texto("actividadEconomica", "Actividad Económica"),
  {
    key: "creditos",
    label: "Ciclos",
    align: "center",
    total: true,
    valor: (c) => c.creditos,
  },
  {
    key: "promedio",
    label: "Promedio",
    align: "center",
    valor: (c) => c.promedio.toFixed(2),
    excel: (c) => Number(c.promedio.toFixed(2)),
  },
];

const ClientesGestor = () => {
  const [data, setData] = useState([]);

  const { selectedSortBy, selectedStatus } = useParams();
  const { setIsLoading, setIsUnautorized, title, slogan, icon } =
    useContext(DataContext);

  const token = getToken();
  const user = getUser();
  const rol = getRol();

  const manejarError = useCallback(
    (result) => {
      if (result.error === "Unauthorized") {
        setIsUnautorized(true);
        return;
      }
      simpleMessage(result.error, "error");
    },
    [setIsUnautorized]
  );

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getClientsReportAsync(token, {
        selectedSortBy,
        selectedStatus,
      });
      setIsLoading(false);

      if (!result.statusResponse) {
        manejarError(result);
        return;
      }
      setData(result.data.result);
    })();
  }, [token, selectedSortBy, selectedStatus, setIsLoading, manejarError]);

  return (
    <ReporteAgrupado
      tituloReporte="Reporte de Clientes"
      nombreArchivo="Clientes"
      parametros={[
        {
          label: "Tipo Cliente",
          valor: ESTADOS[selectedStatus] ?? "Clientes Activos e Inactivos",
        },
      ]}
      columnas={COLUMNAS}
      data={data}
      unidad="cliente"
      unidadPlural="clientes"
      ordenInicial={
        parseInt(selectedSortBy) === ORDEN_POR_PROMEDIO ? "promedio" : "fullName"
      }
      contexto={{ title, slogan, icon, user, rol }}
    />
  );
};

export default ClientesGestor;
